import type { MigrationLegacyClient, MigrationLegacyPhone } from '../types';

export function formatDateTime(value: string): string {
  return new Date(value).toLocaleString('pt-BR', {
    dateStyle: 'short',
    timeStyle: 'short',
  });
}

export function isPhoneLinkedToV2(phone: MigrationLegacyPhone): boolean {
  return phone.linkedToV2 !== false;
}

export function hasAnyHistory(client: MigrationLegacyClient): boolean {
  return client.phones.some((phone) => phone.hasHistory);
}

export function countPhonesWithHistory(client: MigrationLegacyClient): number {
  return client.phones.filter((phone) => phone.hasHistory).length;
}

export function findPhone(
  client: MigrationLegacyClient | null | undefined,
  phoneId: string,
): MigrationLegacyPhone | undefined {
  return client?.phones.find((p) => p.id === phoneId);
}

/** Clamp history window to backend contract (1–180). */
export function clampMigrationDays(value: number): number {
  if (!Number.isFinite(value)) return 7;
  return Math.min(180, Math.max(1, Math.trunc(value)));
}
